var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScheduleRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "56px",
    viewBox: "0 0 62 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group Copy 6@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Schedule-(-Coach-)-new",
    transform: "translate(-1581.000000, -796.000000)",
    fill: "#808080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-6",
    transform: "translate(1581.000000, 796.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.1157143,28.3428571 L42.0271429,28.3428571 C41.9385714,28.3428571 41.7614286,28.2542857 41.7614286,28.0771429 L41.7614286,26.8371429 C41.7614286,26.7485714 41.85,26.5714286 42.0271429,26.5714286 L42.1157143,26.5714286 C42.2042857,26.5714286 42.3814286,26.66 42.3814286,26.8371429 L42.3814286,28.1657143 C42.3814286,28.2542857 42.2042857,28.3428571 42.1157143,28.3428571",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4858892,28.1076923 C42.4858892,28.5923077 42.1410616,29.0076923 41.7962341,29.0076923 L41.520372,29.0076923 C41.1065789,29.0076923 40.8307168,28.5923077 40.8307168,28.1076923 L40.8307168,24.9923077 L38.8996823,25.0615385 C38.7617513,25.0615385 38.6238203,24.9230769 38.6238203,24.7153846 C38.6238203,24.5076923 38.7617513,24.3692308 38.8996823,24.3692308 L40.8996823,24.3 L40.8996823,23.7461538 C40.8996823,23.2615385 41.2445099,22.8461538 41.5893375,22.8461538 L41.8651996,22.8461538 C42.2789927,22.8461538 42.5548547,23.2615385 42.5548547,23.7461538 L42.5548547,28.1076923 L42.4858892,28.1076923 Z M47.7241379,54.2769231 L47.7241379,0 L31.0344828,0 L16.4827586,0 L16.0689655,0 L16.0689655,54.2076923 L0,54.2076923 L0,55.8 L16.7586207,55.8 L46.3551402,55.7444303 L46.3551402,1.59230769 L46.137931,1.59230769 L46.137931,55.8 L62,55.8 L62,54.2076923 L47.7241379,54.2076923 L47.7241379,54.2769231 Z",
    id: "Fill-3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleRoom);
export default __webpack_public_path__ + "static/media/scheduleRoom.0a877b3f73d8ccc6e8afa3bdd2515fb7.svg";
export { ForwardRef as ReactComponent };